<template>
    <div class="order-list">
        <div class="order-list__title-box">
            <h2 class="order-list__title">Последние заказы</h2>
            <router-link to="/orders/list" class="order-list__link" v-if="props.link">Смотреть все</router-link>
        </div>
        <ul class="order-list__list">
            <li class="order-list__item" v-for="(order, index) in orders" :key="index">
                <div class="order-list__content">
                    <span class="order-list__text order-list__index">{{order?.number}}</span>
                    <span class="order-list__text order-list__name">{{order?.information.deceased}}</span>
                    <span class="order-list__text order-list__text_gray order-list__type">{{order.type}}</span>
                    <span class="order-list__text order-list__status"
                    :class="order.status === 'Обработка' ? 'processing' :
                    order.status === 'В работе' ? 'inWork' :
                    order.status === 'Оплачен' ? 'paid' :
                    order.status === 'Сделан' ? 'done' :
                    order.status === 'Закрыт' ? 'closed' :
                    order.status === 'Отказ' ? 'refused' : ''
                    ">{{ order.status }}</span>
                    <span class="order-list__text order-list__price">{{ order.price.final }} &#8381;</span>
                </div>
                <div class="order-list__action-box">
                    <VDropdown>
                        <button class="order-list__action">
                            <icon-component class="order-list__icon" name="action" width="22" height="22"/>
                        </button>
                        <template #popper>
                          <div class="order-list__option-box">
                            <router-link :to="{ name: 'order', params: { orderId: order._id } }" class="order-list__option">Подробнее</router-link>
                            <router-link :to="{ name: 'edit', params: { orderId: order._id } }" class="order-list__option">Редактировать</router-link>
                            <button class="order-list__option" v-if="role !== UserRole.USER && role !== UserRole.MANAGER" @click="isDelete = order._id">В архив</button>
                          </div>
                        </template>
                    </VDropdown>
                </div>
                <popup-component :mt="true" :isOpen="openPopup === order._id" @close="openPopup = '', activePayment = false">
                    <template #title>Платежи</template>
                    <template #additional_title_info>
                        <span class="payments__title payments__title_gold">Номер заказа: {{order.region.slug + order.index}}</span>
                        <span class="payments__title payments__title_gold">ФИО покойного: {{order?.information.deceased}}</span>
                    </template>
                    <template #content>
                        <div class="payments__information">
                            <div class="payments__information-item">
                                <span class="payments__title">Цена</span>
                                <span class="payments__text payments__text_np">{{order.price.total}} руб</span>
                            </div>
                            <div class="payments__information-item">
                                <span class="payments__title">Скидка</span>
                                <span class="payments__text payments__text_np">{{order.price.discount}} руб</span>
                            </div>
                            <div class="payments__information-item">
                                <span class="payments__title">Цена со скидкой</span>
                                <span class="payments__text payments__text_np">{{order.price.final}} руб</span>
                            </div>
                            <div class="payments__information-item">
                                <span class="payments__title">Оплачено</span>
                                <span class="payments__text payments__text_np">{{order.payments.reduce((sum, item) => {return sum + item.amount}, 0)}} руб</span>
                            </div>
                            <div class="payments__information-item">
                                <span class="payments__title payments__title_gold">Остаток</span>
                                <span class="payments__text payments__text_np">{{(order.price.final - order.payments.reduce((sum, item) => {return sum + item.amount}, 0)).toFixed(2)}} руб</span>
                            </div>
                        </div>
                        <ul class="payments">
                            <li class="payments__item">
                                <span class="payments__text">№</span>
                                <span class="payments__text">Платеж</span>
                                <span class="payments__text payments__text_gray">Метод</span>
                                <span class="payments__text">Дата</span>
                            </li>
                            <li class="payments__item" v-for="(item, index) in order.payments">
                                <span class="payments__text">{{index + 1}}</span>
                                <span class="payments__text">{{`${item.amount} руб.`}}</span>
                                <span class="payments__text payments__text_gray">{{item.method}}</span>
                                <span class="payments__text">{{new Date(item.date).toLocaleDateString()}}</span>
                            </li>
                        </ul>
                        <div class="payments-box" v-if="+(order.price.final - order.payments.reduce((sum, item) => {return sum + item.amount}, 0)).toFixed(2) > 0">
                            <button-component buttonText="Добавить платеж" @click="activePayment = true" v-if="!activePayment && role !==UserRole.MANAGER"/>
                            <OrderPaymentsComponent :id="order._id" @close="activePayment = false" @newPayment="setPayment" v-if="activePayment" :remains="+(order.price.final - order.payments.reduce((sum, item) => {return sum + item.amount}, 0)).toFixed(2)"/>
                        </div>
                    </template>
                </popup-component>
                <popup-component :mt="true" :isOpen="isDelete === order._id" @close="isDelete = ''">
                    <template #title>
                        Вы хотите удалить заказ?
                    </template>
                    <template #content>
                        <div class="delete-box">
                            <button-component class="delete delete_success" buttonText="Да" @click="deleteOrder(order._id)"/>
                            <button-component class="delete delete_close" buttonText="Нет" @click="isDelete = ''"/>
                        </div>
                    </template>
                </popup-component>
            </li>
        </ul>
    </div>
</template>
<script setup lang="ts">
import buttonComponent from './buttonComponent.vue';
import OrderPaymentsComponent from './orderPaymentsComponent.vue';
import PopupComponent from '../entities/popupComponent.vue'
import axios from '../app/lib/api';
import { Order, OrderPayment, OrderStatus } from '../app/lib/types/orders';
import iconComponent from './iconComponent.vue';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { onMounted, ref, watch } from 'vue';
import toast from '../app/lib/hooks/errorToast';
import { omit } from 'lodash';
import { UserRole } from '../app/lib/types/users';
import {useLoadingStore} from '../app/store/store';
import { userInfo } from 'os';
dayjs.extend(isBetween)

const props = defineProps({
    margin: {
        type: Boolean
    },
    link: {
        type: Boolean
    },
    sorting: {
        type: Boolean
    },
    date: {
        type: Array
    },
    filtered: {
        type: Boolean
    },
    quantity: {
        type: Number,
        default: 0
    }
})
const loading = useLoadingStore()
const orders = ref([] as unknown as Order[])
const statuses = Object.values( omit(OrderStatus, 'archive'))
const role = localStorage.getItem("role")
const openPopup = ref("")
const isDelete = ref("")
const activePayment = ref(false)
const userId = ref("")

onMounted(() => {
    axios.users.getUserInfo()
    .then((res: any) => {
        userId.value = res.data.userId
    })
    
    loading.loading()
    let filter = {
        perPage: props.quantity,
        search: {searchBy: [{field: 'number', value: ''}]}
    }
    axios.order.getOrderList(filter)
    .then((res: any) => {
        orders.value = res.data.result
        loading.load()
    })
    .catch((err: any) => {
        loading.load()
        toast('error', "Не удалось загрузить заказы:" + err)
    })
})

async function setStatus(id: string, status: OrderStatus) {
    try {
        loading.loading()
        await axios.order.updateOrderStatus(id, status)
        const order = orders.value.find(order => order._id === id )
        if(order){
            order.status = status
        }
        loading.load()
    } catch (error: any) {
        loading.load()
        toast("error", error.response.data.message)
    }
}

function setPayment(data: {id: string, payment: OrderPayment}) {
    const order = orders.value.find(order => order._id === data.id)
    if(order){
        order.payments.push(data.payment)
    }
}

async function deleteOrder(id: string) {
    try {
        loading.loading()
        await axios.order.updateOrderStatus(id, OrderStatus.archive)
        orders.value = orders.value.filter(order => order._id !== id)
        loading.load()
    } catch (error: any) {
        toast("error", error.response.data.message)
        loading.load()
    }
}
</script>